/**
 * AI model selection API
 */

import { fetchApi } from './fetch';

export type AIProvider = 'anthropic' | 'openai' | 'google';

export interface AIModel {
  id: string;
  name: string;
  provider: AIProvider;
  inputCostPerMillion: number;
  outputCostPerMillion: number;
  description: string;
  isDefault?: boolean;
  supportsThinking?: boolean;
}

export interface ModelSetting {
  modelId: string;
  model: AIModel;
}

/**
 * List all available Claude models.
 * No auth required — same list for every user.
 */
export async function getAvailableModels(): Promise<AIModel[]> {
  return fetchApi<AIModel[]>('/settings/models');
}

/**
 * Get the current user's selected model.
 */
export async function getSelectedModel(): Promise<ModelSetting> {
  return fetchApi<ModelSetting>('/settings/model');
}

/**
 * Set the current user's model preference.
 */
export async function setSelectedModel(
  modelId: string
): Promise<{ success: boolean; modelId: string; model: AIModel }> {
  return fetchApi<{ success: boolean; modelId: string; model: AIModel }>(
    '/settings/model',
    { method: 'PUT', body: JSON.stringify({ modelId }) }
  );
}
